import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useGlobalDampedScroll } from "./hooks/useGlobalDampedScroll";
import { useState, useEffect } from "react";
import SubmitModal from "./pages/home/components/SubmitModal";

function AppInner() {
  useGlobalDampedScroll();
  const [submitOpen, setSubmitOpen] = useState(false);

  useEffect(() => {
    const handler = () => setSubmitOpen(true);
    window.addEventListener('open-submit-modal', handler);
    return () => window.removeEventListener('open-submit-modal', handler);
  }, []);

  return (
    <>
      <AppRoutes />
      <SubmitModal open={submitOpen} onClose={() => setSubmitOpen(false)} />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppInner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
